import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FranchisePage from "../pages/franchise/page";
import SolutionsPage from "../pages/solutions/page";
import AboutPage from "../pages/about/page";
import ExpertsPage from "../pages/experts/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail";
import ContactPage from "../pages/contact/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/solutions",
    element: <SolutionsPage />,
  },
  {
    path: "/management",
    element: <ExpertsPage />,
  },
  {
    path: "/franchise",
    element: <FranchisePage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;